import React, { useState, useEffect } from 'react';
import '../../styles/AdminModal.css';
import { addBlogCategory } from '../../services/AdminBlogService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import BlogCategoryForm from '../../forms/blog/BlogCategoryForm';

const BlogCategoryAddModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    is_active: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        name: '',
        description: '',
        is_active: true,
      });
      setErrors({});
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSave = async () => {
    if (!formData.name.trim()) {
      setErrors({ name: 'Name is required' });
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      await addBlogCategory(formData);
      onSuccess();
    } catch (error) {
      console.error('Error adding blog category:', error);
      setErrors({ general: 'Failed to add blog category. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Add Blog Category</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>

        {errors.general && (
          <div className="error-message">{errors.general}</div>
        )}

        <div className="admin__modal-body">
          <BlogCategoryForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
          />
        </div>

        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="button" onClick={handleSave} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogCategoryAddModal; 